import { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { LineChart, Receipt } from "lucide-react";
import Finance from "@/pages/Finance";
import Cobrancas from "@/pages/Cobrancas";
import { TopBar } from "@/components/PageShell";

const NAVY = "#0E1D2D";
const GOLD = "#C9953D";

const TABS = [
  { key: "overview", label: "Visão Geral", icon: LineChart, testid: "finance-tab-overview" },
  { key: "cobrancas", label: "Cobranças", icon: Receipt, testid: "finance-tab-cobrancas" },
];

export default function FinanceHub() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") === "cobrancas" ? "cobrancas" : "overview";
  const [tab, setTab] = useState(initial);

  const setActive = (k) => {
    setTab(k);
    const p = new URLSearchParams(params);
    if (k === "overview") p.delete("tab"); else p.set("tab", k);
    setParams(p, { replace: true });
  };

  const content = useMemo(() => {
    if (tab === "cobrancas") return <Cobrancas embedded />;
    return <Finance embedded />;
  }, [tab]);

  return (
    <div className="flex-1 min-w-0 flex flex-col" data-testid="finance-hub-page">
      <TopBar/>
      <div className="border-b border-slate-200 bg-white sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-10 py-3 flex items-center gap-2 overflow-x-auto">
          {TABS.map((t) => {
            const active = tab === t.key;
            const Icon = t.icon;
            return (
              <button key={t.key} onClick={() => setActive(t.key)}
                data-testid={t.testid}
                className={`h-9 px-4 rounded-full text-[12.5px] font-semibold inline-flex items-center gap-1.5 border transition ${
                  active
                    ? "bg-slate-900 text-white border-slate-900"
                    : "bg-white text-slate-700 border-slate-200 hover:border-slate-300"
                }`}>
                <Icon className="w-3.5 h-3.5"/> {t.label}
              </button>
            );
          })}
        </div>
      </div>
      {content}
    </div>
  );
}
